module.exports = __webpack_public_path__ + "img/P150T_weapon_138.929be287.png";